import classNames from 'classnames';

import { Leave } from '../types';
import { Interval } from 'components/types';

import Absence from './Absence';
import { Icon } from '@sdb/planning-ui';

type Props = {
  absence: Leave;
  interval: Interval;
};

export default function LeaveAbsence({ absence, interval }: Props) {
  const { note, dutyHourType } = absence;
  const { colorCode: dhtColor = '#33ff99' } = dutyHourType;
  const isLeaveRequest = !absence.isApproved;

  return (
    <Absence
      absence={absence}
      className={classNames('absence', 'leave', {
        'is-leave-request': isLeaveRequest
      })}
      borderColor={dhtColor}
      interval={interval}
      background="white"
    >
      <>{note && <Icon type="comment" fontSize="small" />}</>
    </Absence>
  );
}
